<div class="support-tab-view" *ngIf="view === 'list'">
  <div class="support-list-header">
    <span class="lbl">{{ "support_popup.case.lbl_your_cases" | translate }}</span>
    <button type="button" class="ft-btn ft-btn-active" (click)="toggleNewCaseForm()">
      + {{ "support_popup.case.lbl_new_case" | translate }}
    </button>
  </div>

  <div class="new-case-form" [class.visible]="isNewCaseFormOpen" *ngIf="isNewCaseFormOpen" [formGroup]="newCaseForm">
    <div class="field">
      <label for="nc-heading">{{ "support_popup.case.lbl_heading" | translate }}</label>
      <input id="nc-heading" type="text" formControlName="heading" [placeholder]="'support_popup.case.lbl_heading_placeholder' | translate" maxlength="120" />
    </div>
    <div class="field">
      <label for="nc-message">{{ "support_popup.lbl_message" | translate }}</label>
      <div class="textarea-wrapper" *ngIf="composerTarget !== 'newCase'">
        <textarea #newCaseMessageTextarea id="nc-message" formControlName="message"
          (input)="onTextareaInput(newCaseMessageTextarea)"
          [placeholder]="'support_popup.case.lbl_message_placeholder' | translate"></textarea>
        <button type="button" class="btn-expand-composer" (click)="onExpandComposer('newCase')"
          [attr.aria-label]="'support_popup.case.lbl_expand_composer' | translate" [attr.title]="'support_popup.case.lbl_expand_composer' | translate">
          <i class="fa fa-expand"></i>
        </button>
      </div>
    </div>
    <p class="text-danger" *ngIf="createError">{{ "support_popup.case.lbl_create_error" | translate }}</p>
    <div class="form-actions">
      <button type="button" class="ft-btn ft-btn-active-not-selected" (click)="toggleNewCaseForm()">{{ "lbl_cancel" | translate }}</button>
      <button type="button" class="ft-btn ft-btn-active" [disabled]="!isNewCaseFormValid() || isCreating" (click)="submitNewCase()">{{ "support_popup.lbl_send" | translate }}</button>
    </div>
  </div>

  <p class="text-danger" *ngIf="loadError">{{ "support_popup.case.lbl_load_error" | translate }}</p>
  <p class="text-danger" *ngIf="threadLoadError">{{ "support_popup.case.lbl_thread_load_error" | translate }}</p>

  <div class="tab-spinner" *ngIf="isLoading">
    <img src="/assets/images/icons/loading.svg" alt="Loading..." />
  </div>

  <div class="seg-track" *ngIf="!isLoading && !loadError">
    <button type="button" class="seg" [class.active]="statusFilter === 'All'" (click)="setStatusFilter('All')">{{ "support_popup.case.lbl_filter_all" | translate }}</button>
    <button type="button" class="seg" [class.active]="statusFilter === 'Open'" (click)="setStatusFilter('Open')">{{ "support_popup.case.lbl_filter_open" | translate }}</button>
    <button type="button" class="seg" [class.active]="statusFilter === 'Closed'" (click)="setStatusFilter('Closed')">{{ "support_popup.case.lbl_filter_closed" | translate }}</button>
  </div>

  <ul class="case-list" *ngIf="!isLoading && !loadError">
    <li class="case-row" *ngFor="let supportCase of filteredCases; trackBy: trackBySupportId" [class.disabled]="isThreadLoading" [class.unread]="supportCase.hasUnreadReply" (click)="!isThreadLoading && openCase(supportCase.supportId)">
      <span class="case-number" *ngIf="isCaseNumberEnabled">{{ supportCase.supportNumber ? '#' + supportCase.supportNumber : '—' }}</span>
      <span class="case-main">
        <div class="case-info">
          <div class="case-heading" [class.unread]="supportCase.hasUnreadReply">
            {{ supportCase.topic }}
          </div>
          <div class="case-sub">
            <span class="channel-chip">
              {{ (supportCase.channel === 'Email' ? 'support_popup.case.lbl_channel_email' : 'support_popup.case.lbl_channel_webapp') | translate }}
            </span>
          </div>
        </div>
        <span class="new-case-dot" *ngIf="supportCase.hasUnreadReply" title="{{ 'support_popup.case.lbl_unread_reply' | translate }}" [attr.aria-label]="'support_popup.case.lbl_unread_reply' | translate"></span>
      </span>
      <span class="status-label" [ngClass]="supportCase.status === 'Open' ? 'open' : 'closed'">
        {{ (supportCase.status === 'Open' ? 'support_popup.case.lbl_status_open' : 'support_popup.case.lbl_status_closed') | translate }}
      </span>
    </li>
  </ul>

  <div class="empty-hint" *ngIf="!isLoading && !loadError && filteredCases.length === 0">
    {{ (cases.length === 0 ? "support_popup.case.lbl_no_cases" : "support_popup.case.lbl_no_filter_cases") | translate }}
  </div>
</div>

<div class="support-tab-view thread-view" *ngIf="view === 'thread' && activeThread">
  <div class="thread-header">
    <button type="button" class="back-btn" (click)="backToList()" [attr.aria-label]="'support_popup.case.lbl_back_to_list' | translate">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="thread-title-group">
      <div class="thread-title">{{ activeThread.topic }}</div>
    </div>
    <span class="status-label" [ngClass]="activeThread.status === 'Open' ? 'open' : 'closed'">
      {{ (activeThread.status === 'Open' ? 'support_popup.case.lbl_status_open' : 'support_popup.case.lbl_status_closed') | translate }}
    </span>
  </div>

  <div class="thread-messages">
    <div class="msg" *ngFor="let message of activeThread.messages" [ngClass]="authorClass(message.authorType)">
      <div class="bubble"><app-email-message [message]="message.message"></app-email-message></div>
      <div class="meta">{{ message | authorLabel }} · {{ message.createdOn | osloDate }}</div>
    </div>
  </div>

  <div class="reply-box">
    <div class="textarea-wrapper" *ngIf="composerTarget !== 'reply'">
      <textarea #replyTextarea
        [formControl]="replyText"
        (input)="onTextareaInput(replyTextarea)"
        [placeholder]="(activeThread.status === 'Closed' ? 'support_popup.case.lbl_reply_placeholder_closed' : 'support_popup.case.lbl_reply_placeholder') | translate"></textarea>
      <button type="button" class="btn-expand-composer" *ngIf="activeThread.status !== 'Closed'" (click)="onExpandComposer('reply')"
        [attr.aria-label]="'support_popup.case.lbl_expand_composer' | translate" [attr.title]="'support_popup.case.lbl_expand_composer' | translate">
        <i class="fa fa-expand"></i>
      </button>
    </div>
    <p class="text-danger" *ngIf="replyError">{{ 'support_popup.case.lbl_reply_error' | translate }}</p>
    <div class="reply-actions">
      <button type="button" class="ft-btn ft-btn-active-not-selected btn-close-case" *ngIf="activeThread.status !== 'Closed'"
        (click)="openRatingModal()">
        {{ 'support_popup.case.lbl_close_case' | translate }}
      </button>
      <button type="button" class="ft-btn ft-btn-active btn-send-reply"
        [disabled]="activeThread.status === 'Closed' || replyText.invalid || replyText.disabled || isSendingReply || !replyText.value?.trim()"
        (click)="sendReply()">
        {{ 'support_popup.lbl_send' | translate }}
      </button>
    </div>
  </div>

  <div class="closed-notice" *ngIf="activeThread.status === 'Closed'">
    {{ 'support_popup.case.lbl_closed_notice' | translate }}
  </div>
</div>

<div class="composer-backdrop" *ngIf="composerOpen" (click)="onCloseComposer()">
  <div class="composer-modal" (click)="$event.stopPropagation()">
    <div class="composer-header">
      <span class="composer-title">{{ composerConfig.titleKey | translate }}</span>
      <button type="button" class="btn-close-composer" (click)="onCloseComposer()"
        [attr.aria-label]="'support_popup.case.lbl_collapse_composer' | translate">&times;</button>
    </div>
    <textarea
      [formControl]="composerConfig.control"
      [placeholder]="composerConfig.placeholderKey | translate"></textarea>
    <p class="text-danger" *ngIf="composerTarget === 'reply' && replyError">{{ 'support_popup.case.lbl_reply_error' | translate }}</p>
    <p class="text-danger" *ngIf="composerTarget === 'newCase' && createError">{{ 'support_popup.case.lbl_create_error' | translate }}</p>
    <div class="reply-actions" *ngIf="composerTarget === 'reply'">
      <button type="button" class="ft-btn ft-btn-active btn-send-reply"
        [disabled]="replyText.invalid || replyText.disabled || isSendingReply || !replyText.value?.trim()"
        (click)="sendReply()">
        {{ 'support_popup.lbl_send' | translate }}
      </button>
    </div>
    <div class="reply-actions" *ngIf="composerTarget === 'newCase'">
      <button type="button" class="ft-btn ft-btn-active btn-send-reply"
        [disabled]="!isNewCaseFormValid() || isCreating"
        (click)="submitNewCase()">
        {{ 'support_popup.lbl_send' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="rating-modal-backdrop" [class.visible]="isRatingModalOpen" *ngIf="isRatingModalOpen">
  <div class="rating-modal">
    <h3>{{ 'support_popup.case.lbl_rating_title' | translate }}</h3>
    <p>{{ 'support_popup.case.lbl_rating_prompt' | translate }}</p>
    <app-face-rating
      [value]="pendingRating"
      [disabled]="isClosingCase"
      (rating)="selectRating($event)"></app-face-rating>
    <p class="text-danger" *ngIf="closeError">{{ 'support_popup.case.lbl_close_error' | translate }}</p>
    <div class="modal-actions">
      <button type="button" class="ft-btn ft-btn-active-not-selected"
        [disabled]="isClosingCase"
        (click)="cancelRatingModal()">
        {{ 'support_popup.case.lbl_rating_cancel' | translate }}
      </button>
      <button type="button" class="ft-btn ft-btn-active btn-rating-confirm"
        [disabled]="pendingRating === null || isClosingCase"
        (click)="confirmClose()">
        {{ 'support_popup.case.lbl_rating_confirm' | translate }}
      </button>
    </div>
  </div>
</div>
